import i18n from "../../../../constants/i18n";
import getKhattabatFilterStore from "../../../../stores/khattabat-stores/filter-store";
import ET3Circle from "../../../../core/et3-circle";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Text from "../../../../core/et3-text";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";

const Title = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX } = theme;
  const isSearchingClients = getKhattabatFilterStore().isSearchingClients.get();

  return (
    <ET3Div
      width={1510}
      height={35}
      alignItems={"flex-start"}
      fDirection={"row"}
      style={{}}
      color={""}
      justifyContent={"flex-start"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => {}}
    >
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={25}
        isSpan={true}
        text={i18n.get("FILTERS")}
        style={{
          textDecoration: "underline"
        }}
        color={""}
      />
      <ET3Circle
        size={10}
        style={{
          backgroundColor: isSearchingClients
            ? colors.all.green
            : colors.all.red
        }}
        color={""}
        withShadow={false}
        onClick={() => void {}}
      />
      <Et3Margin top={0} bottom={0} left={10} right={10} />
      <ET3Div
        width={180}
        height={35}
        alignItems={"center"}
        fDirection={"row"}
        style={{
          borderRadius: 10 * unitX,
          cursor: "pointer"
        }}
        color={isSearchingClients ? colors.all.red : colors.all.dimGray}
        justifyContent={"center"}
        withShadow={false}
        isExtendable={false}
        isScrollable={false}
        onClick={() =>
          isSearchingClients ? getKhattabatFilterStore().resetFilters() : null
        }
      >
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={15}
          isSpan={true}
          text={i18n.get("FILTERS_RESET")}
          style={{}}
          color={isSearchingClients ? colors.all.black : colors.all.white}
        />
      </ET3Div>
    </ET3Div>
  );
});

export default Title;
